import React from 'react'
import TreeItem from '@material-ui/lab/TreeItem'
import { makeStyles, Box, Typography, Radio, styled } from '@material-ui/core'
import { Icon } from '../../eid-icons'

const StyledRadio = styled(Radio)({
    padding: '2px',
    maxHeight: '20px',
    '&:hover': {
        backgroundColor: '#d2d2d9',
    },
})

const useStyles = makeStyles({
    root: {
        '&:focus > $content': {
            backgroundColor: 'inherit',
        },
    },

    iconContainer: {
        '& .close': {
            opacity: 0.3,
        },
    },
    group: {
        marginLeft: 12,
    },
    label: (props) => ({
        color: props.selected ? '#000000' : '#767676',
        width: 'max-content',
        borderRadius: '5px',
        padding: '5px',
        '&:hover': {
            backgroundColor: '#f1f1f4',
        },
        '& .search-highlight': {
            color: '#01745f',
            fontWeight: 600,
            textDecoration: 'underline',
        },
    }),
    content: {
        marginBottom: '6px',
        marginTop: '6px',

        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
})

const highlight = (text, searchKey) => {
    searchKey = new RegExp('(' + searchKey + ')', 'gi')
    return text.split(searchKey).map((o, i) =>
        i % 2 === 1 ? (
            <span className="search-highlight" key={i}>
                {o}
            </span>
        ) : (
            o
        ),
    )
}

const SubTreeItem = ({
    index,
    label,
    count,
    highlightText,
    selected,
    onClick,
    ...rest
}) => {
    const classes = useStyles({ selected })

    let labelToShow

    if (highlightText && highlightText.length) {
        labelToShow = highlight(label, highlightText)
    } else {
        labelToShow = label
    }

    return (
        <TreeItem
            classes={classes}
            {...rest}
            label={
                <Box display="flex" height="100%" alignItems="center">
                    <StyledRadio
                        checkedIcon={<Icon name="RadioFilled" />}
                        icon={<Icon name="Radio" />}
                        checked={selected ?? false}
                        onClick={onClick}
                    />
                    <Typography
                        variant="body2"
                        style={{
                            wordBreak: 'break-all',
                            paddingLeft: '12px',
                        }}
                    >
                        {labelToShow}
                    </Typography>
                    {count !== undefined && (
                        <Typography
                            variant="body2"
                            style={{ marginLeft: '5px', color: '#919193' }}
                        >
                            ({count})
                        </Typography>
                    )}
                </Box>
            }
        />
    )
}

export default SubTreeItem
